import React, { useId } from "react";

import { FieldShell, TextField, describedBy } from "./fields";
import PhoneInput from "../Common/PhoneInput/PhoneInput";

const MobileField = ({
  label,
  name,
  onChange,
  disabled,
  value,
  error = "",
  style,
}) => {
  const id = useId();
  return (
    <FieldShell id={id} label={label} error={error}>
      <PhoneInput
        id={id}
        name={name}
        value={value}
        disabled={disabled}
        style={style}
        autoComplete="tel"
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(id, error)}
        onChange={(nextValue) =>
          onChange({ target: { name, value: nextValue } })
        }
      />
    </FieldShell>
  );
};

// Hook-free: Form calls renderers as plain functions.
const TextFieldRenderer = ({ styles, ...props }) =>
  props.name === "mobile" ? (
    <MobileField {...props} />
  ) : (
    <TextField {...props} />
  );

export default TextFieldRenderer;
